import { useState, useEffect } from 'react';
import { Tabs, TabsList, TabsTrigger, TabsContent } from '@/components/ui/tabs';
import { KanbanView } from './KanbanView';
import { CalendarView } from './CalendarView';
import { SquareKanban, Calendar } from 'lucide-react';
import { useLocationContext } from '@/contexts/LocationContext';
import Cookies from 'js-cookie';

export function OverviewView() {
  const { selectedLocation } = useLocationContext();
  const [activeTab, setActiveTab] = useState(() => {
    return Cookies.get('overviewActiveTab') || 'kanban';
  });

  useEffect(() => {
    Cookies.set('overviewActiveTab', activeTab, { expires: 30 });
  }, [activeTab]);

  return (
    <div className="space-y-6 animate-slide-up">
      <Tabs value={activeTab} onValueChange={setActiveTab} className="w-full">
        <div className="flex justify-center mb-6">
          <TabsList className="grid grid-cols-2 w-fit bg-white/90 shadow-elegant border-0 h-12 p-1">
            <TabsTrigger 
              value="kanban" 
              className="flex items-center gap-2 px-6 py-2 data-[state=active]:bg-blue-500 data-[state=active]:text-white data-[state=active]:shadow-lg transition-all duration-200 rounded-lg"
            >
              <SquareKanban className="w-4 h-4" />
              <span className="font-medium">Kanban Board</span>
            </TabsTrigger>
            <TabsTrigger 
              value="calendar" 
              className="flex items-center gap-2 px-6 py-2 data-[state=active]:bg-blue-500 data-[state=active]:text-white data-[state=active]:shadow-lg transition-all duration-200 rounded-lg"
            >
              <Calendar className="w-4 h-4" />
              <span className="font-medium">Calendar View</span>
            </TabsTrigger>
          </TabsList>
        </div>
        
        <TabsContent value="kanban" className="mt-6 animate-fade-in">
          <KanbanView />
        </TabsContent>
        
        <TabsContent value="calendar" className="mt-6 animate-fade-in">
          <CalendarView selectedLocation={selectedLocation} />
        </TabsContent>
      </Tabs>
    </div>
  );
} 